import { render, staticRenderFns } from "./FlavorConfirm.vue?vue&type=template&id=c9f2bbbe&scoped=true&"
import script from "./FlavorConfirm.vue?vue&type=script&lang=js&"
export * from "./FlavorConfirm.vue?vue&type=script&lang=js&"
import style0 from "./FlavorConfirm.vue?vue&type=style&index=0&id=c9f2bbbe&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f2bbbe",
  null
  
)

export default component.exports